import React from 'react';
import { Accordion } from './Accordion';
import { BuyButton } from './BuyButton';
import { MODULES } from '../data/content';
export function Modules() {
  return <section className="px-5 py-10" data-id="element-94">
      <div className="mx-auto max-w-md" data-id="element-95">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-96">
          Para eso hicimos{' '}
          <span className="text-[#F5C518]" data-id="element-97">Hyrox Definitivo 360 Coach</span>
        </h2>
        <p className="mt-3 text-center text-sm text-neutral-400" data-id="element-98">
          7 módulos completos, paso a paso. Tocá cada uno para ver todo lo que
          incluye.
        </p>

        <div className="mt-6 space-y-3" data-id="element-99">
          {MODULES.map((m, i) => <Accordion key={i} emoji={m.emoji} title={m.title} defaultOpen={i === 0} data-id="element-100">
              <ul className="space-y-2" data-id="element-101">
                {m.points.map((point, j) => <li key={j} className="flex gap-2 text-[14px] leading-snug text-neutral-300" data-id="element-102">
                    <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-[#F5C518]" data-id="element-103" />
                    <span data-id="element-104">{point}</span>
                  </li>)}
              </ul>
            </Accordion>)}
        </div>

        <div className="mt-7" data-id="element-105">
          <BuyButton data-id="element-106" />
        </div>
      </div>
    </section>;
}